import { FilterConfig } from '@/app/(authenticated)/(marketplace)/collection/[...slug]/types';
import {
  ACCESSORIES,
  APPAREL,
  BATH_AND_BEAUTY,
  CATEGORY_GROUP,
  FOOTWEAR,
  HOUSEWARES,
} from '@/types/categories';
import { CategoryGroup, Collection } from '@/types/collections';
import { FilterAttribute } from '@/types/filterAttribute';

export const collectionFilterConfigs: Record<Collection, FilterConfig> = {
  all: {
    filterString: '',
    tagFilters: [],
    facetFilters: [],
    pageHeader: 'All',
  },
  new: {
    filterString: '',
    tagFilters: ['New'],
    facetFilters: [],
    pageHeader: 'New on Ghost',
  },
  featured: {
    filterString: '',
    tagFilters: ['Featured'],
    facetFilters: [],
    pageHeader: 'Featured',
  },
  stockx: {
    filterString: '',
    tagFilters: ['StockX'],
    facetFilters: [],
    pageHeader: 'Good for StockX',
  },
  streetwear: {
    filterString: '',
    tagFilters: ['Streetwear'],
    facetFilters: [],
    pageHeader: 'Streetwear',
  },
  offprice: {
    filterString: '',
    tagFilters: ['Offprice'],
    facetFilters: [],
    pageHeader: 'Offprice',
  },
  wholesale: {
    filterString: '',
    tagFilters: ['Wholesale'],
    facetFilters: [],
    pageHeader: 'Wholesale',
  },
  trending: {
    filterString: '',
    tagFilters: ['Trending'],
    facetFilters: [],
    pageHeader: 'Trending',
  },
  ['amazon-friendly']: {
    filterString: '',
    tagFilters: ['Amazon Friendly'],
    facetFilters: [],
    pageHeader: 'Amazon Friendly',
  },
  ['ships-fast']: {
    filterString: '',
    tagFilters: ['Ships Fast'],
    facetFilters: [],
    pageHeader: 'Ships Fast',
  },
  ['hot-sellers']: {
    filterString: '',
    tagFilters: ['Best Sellers'],
    facetFilters: [],
    pageHeader: 'Hot Sellers',
  },
  ['spring-essentials']: {
    filterString: '',
    tagFilters: ["Spring/Summer '24"],
    facetFilters: [],
    pageHeader: 'Spring Essentials',
  },
  ['summer-essentials']: {
    filterString: '',
    tagFilters: ['Summer Top Sellers'],
    facetFilters: [],
    pageHeader: 'Sun, Sand & Sea',
  },
  ['luxury-lineup']: {
    filterString: '',
    tagFilters: ['Luxury Lineup'],
    facetFilters: [],
    pageHeader: 'Luxury Lineup',
  },
  ['ghost-x-whatnot']: {
    filterString: '',
    // We are using the "Live Sellers" tag to filter down for the Whatnot Event
    tagFilters: ['Live Sellers'],
    facetFilters: [],
    pageHeader: 'Ghost x Whatnot',
  },
};

export const categoryGroupFilterConfigs: Record<CategoryGroup, FilterConfig> = {
  apparel: {
    filterString: `${CATEGORY_GROUP}:"${APPAREL}"`,
    tagFilters: [],
    facetFilters: [],
    pageHeader: 'Apparel',
  },
  accessories: {
    filterString: `${CATEGORY_GROUP}:"${ACCESSORIES}"`,
    tagFilters: [],
    facetFilters: [],
    pageHeader: 'Accessories',
  },
  beauty: {
    filterString: `${CATEGORY_GROUP}:"${BATH_AND_BEAUTY}"`,
    tagFilters: [],
    facetFilters: [],
    pageHeader: 'Beauty',
  },
  footwear: {
    filterString: `${CATEGORY_GROUP}:"${FOOTWEAR}"`,
    tagFilters: [],
    facetFilters: [],
    pageHeader: 'Footwear',
  },
  housewares: {
    filterString: `${CATEGORY_GROUP}:"${HOUSEWARES}"`,
    tagFilters: [],
    facetFilters: [],
    pageHeader: 'Housewares',
  },
};

export const recommendationFilterConfigs: Record<FilterAttribute, FilterConfig> = {
  platforms: {
    filterString: '',
    tagFilters: [],
    facetFilters: [],
    pageHeader: 'For your marketplaces',
  },
  specialties: {
    filterString: '',
    tagFilters: [],
    facetFilters: [],
    pageHeader: 'Specialties for you',
  },
  brands: {
    filterString: '',
    tagFilters: [],
    facetFilters: [],
    pageHeader: 'Brands for you',
  },
  compositeCategories: {
    filterString: '',
    tagFilters: [],
    facetFilters: [],
    pageHeader: 'Categories for you',
  },
  percentOffMsrp: {
    filterString: '',
    tagFilters: [],
    facetFilters: [],
    pageHeader: 'Your discount preferences',
  },
};
